// extracted by mini-css-extract-plugin
module.exports = {"container":"Modal_Header_container__uN9qb","iconSlot":"Modal_Header_iconSlot__9q3nz"};